import React, { useEffect, useState } from "react";
import {
  Tabs,
  Input,
  Card,
  Button,
  Divider,
  Spin,
  message,
  Modal,
  List,
  Radio,
} from "antd";
import { CaretLeftOutlined } from "@ant-design/icons";
import axios from "axios";
import "../../../config";
import { useParams } from "react-router-dom";
import ProductAdminCard from "./ProductAdminCard";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";

const { TabPane } = Tabs;
const { Search } = Input;

const ProductAdminList = () => {
  let { categoryIDQuery, categoryName } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const [products, setProducts] = useState([]);
  const [showProdStatus] = useState(false);
  const [loading, setLoading] = useState(true);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImageID, setSelectedImageID] = useState(null);

  const [currentProductID, setCurrentProductID] = useState(null);

  useEffect(() => {
    document.title = "JOJ | " + categoryName;
    window.scrollTo(0, 0);
    getListofProduct();
  }, []);

  const handleImageClick = async (productId) => {
    setCurrentProductID(productId);
    setIsModalVisible(true);
    fetchProductImages(productId);
  };

  const filteredProducts = products.filter(
    (product) =>
      (activeTab === "All" || product.Status === activeTab) &&
      product.ProductName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  async function getListofProduct() {
    setLoading(true);
    let CategoryID = sessionStorage.getItem("CategoryID");
    if (!CategoryID) {
      CategoryID = categoryIDQuery;
    }
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL +
          "api/Product/ListofProductByCategoryforList?CategoryID=" +
          CategoryID,
        headers: {
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setProducts(response.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
    }
  }

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setProducts((items) => {
        const oldIndex = items.findIndex(
          (item) => item.ProductID === active.id
        );
        const newIndex = items.findIndex((item) => item.ProductID === over.id);

        // Rearrange the items
        const reorderedItems = arrayMove(items, oldIndex, newIndex);

        // Update SortingVal based on the new order
        const updatedItems = reorderedItems.map((item, index) => ({
          ...item,
          SortingVal: index + 1, // Set SortingVal to 1, 2, 3, ...
        }));

        updateSortingNumbersAPI(updatedItems);

        return updatedItems;
      });
    }
  };

  const updateSortingNumbersAPI = async (updatedProducts) => {
    try {
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL +
          "api/Product/SetMultipleProductSortingNumber",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        data: updatedProducts.map((product) => ({
          ProductID: product.ProductID,
          SortingNumber: product.SortingVal,
        })),
      };

      const response = await axios.request(config);
      if (response.status === 200) {
      } else {
        console.error("Failed to update sorting numbers after drag-and-drop.");
      }
    } catch (error) {
      console.error(
        "Error updating sorting numbers after drag-and-drop:",
        error
      );
    }
  };

  const handleSetSortingValues = async () => {
    const updatedProducts = products.map((product, index) => ({
      ...product,
      SortingVal: index + 1, // Set SortingVal to 1, 2, 3, ...
    }));
    setProducts(updatedProducts);

    // Call the API to update sorting numbers for all products
    try {
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL +
          "api/Product/SetMultipleProductSortingNumber",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        data: updatedProducts.map((product) => ({
          ProductID: product.ProductID,
          SortingNumber: product.SortingVal,
        })),
      };

      const response = await axios.request(config);
      if (response.status === 200) {
      } else {
      }
    } catch (error) {}
  };

  const handleSortingChange = async (productId, value) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.ProductID === productId
          ? { ...product, SortingVal: value }
          : product
      )
    );

    // Call the API to update the sorting number
    try {
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL + "api/Product/SetProductSortingNumber",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        params: {
          ProductID: productId,
          SortingNumber: value,
        },
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        console.log("Sorting number updated successfully.");
      } else {
        console.error("Failed to update sorting number.");
      }
    } catch (error) {
      console.error("Error updating sorting number:", error);
    }
  };

  const fetchProductImages = async (productId) => {
    try {
      setLoading(true);
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "get",
        url: global.config.APIURL.BaseURL + "api/Product/GetProductImages",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        params: { ProdID: productId },
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        setImages(response.data);
        const currentDisplayImage = response.data.find(
          (img) => img.IsDisplayImage
        );
        setSelectedImageID(currentDisplayImage?.ImageID || null);
      } else {
        message.error("Failed to fetch product images.");
      }
    } catch (error) {
      console.error("Error fetching product images:", error);
      message.error("Error fetching product images.");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDisplayImage = async () => {
    try {
      setLoading(true);
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL + "api/Product/SetProductDisplayImage",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        data: {
          ProdID: currentProductID,
          DisplayImageID: selectedImageID,
        },
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        message.success("Display image updated successfully.");
        setIsModalVisible(false);
      } else {
        message.error("Failed to update display image.");
      }
    } catch (error) {
      console.error("Error updating display image:", error);
      message.error("Error updating display image.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div style={{ padding: 0 }}>
      <Card>
        <Button
          type="primary"
          icon={<CaretLeftOutlined />}
          onClick={() => window.history.back()}
        >
          Back to Category List
        </Button>
        <Divider />

        <Tabs
          defaultActiveKey="All"
          onChange={(key) => setActiveTab(key)}
          style={{ marginBottom: 16 }}
        >
          <TabPane tab={`All (${products.length})`} key="All" />
          {showProdStatus && (
            <>
              <TabPane
                tab={`Available (${
                  products.filter((p) => p.Status === "Available").length
                })`}
                key="Available"
              />
              <TabPane
                tab={`Out of Stock (${
                  products.filter((p) => p.Status === "Out of Stock").length
                })`}
                key="Out of Stock"
              />
            </>
          )}
        </Tabs>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 24,
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          <Search
            placeholder="Search products..."
            onSearch={(value) => setSearchTerm(value)}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ maxWidth: 300 }}
            allowClear
          />
          <Button onClick={handleSetSortingValues}>Add Default Sorting</Button>
        </div>

        <Spin spinning={loading}>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={filteredProducts.map((product) => product.ProductID)}
              strategy={verticalListSortingStrategy}
            >
              {filteredProducts.map((product) => (
                <SortableItem key={product.ProductID} id={product.ProductID}>
                  <ProductAdminCard
                    product={product}
                    showProdStatus={showProdStatus}
                    onSortingChange={handleSortingChange}
                    onImageClick={handleImageClick} // Pass the handler
                  />
                </SortableItem>
              ))}
            </SortableContext>
          </DndContext>
        </Spin>
      </Card>

      {/* Modal for Display Image Selection */}
      <Modal
        title="Select Display Image"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleSaveDisplayImage}
        confirmLoading={loading}
        okText="Save"
      >
        <List
          dataSource={images}
          renderItem={(image) => (
            <List.Item>
              <Radio
                checked={selectedImageID === image.ImageID}
                onChange={() => setSelectedImageID(image.ImageID)}
              >
                <img
                  src={image.ImageUrl}
                  alt="Product"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginRight: "16px",
                  }}
                />
              </Radio>
            </List.Item>
          )}
        />
      </Modal>
    </div>
  );
};

export default ProductAdminList;
